import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'

export interface NotificationWindows {
  [key: string]: chrome.windows.Window | undefined
}

export interface NotificationWindowsState {
  notificationWindows: NotificationWindows
  setNotificationWindow: (
    tabId: string,
    notificationWindow: chrome.windows.Window | undefined
  ) => void
}

export const createNotificationWindowStore = (storage: StateStorage) =>
  createStore<NotificationWindowsState>(
    storage,
    (set, get) => ({
      notificationWindows: {},
      setNotificationWindow: (tabId, newNotificationWindow) => {
        const notificationWindows = get().notificationWindows
        set({
          notificationWindows: {
            ...notificationWindows,
            [tabId.toString()]: newNotificationWindow,
          },
        })
      },
    }),
    {
      persist: {
        name: 'notificationWindowStore',
        version: 0,
      },
    }
  )
